// @flow

import * as React from "react";
import { useLocation, Switch, Route, Redirect } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { handleOktaRedirect } from "../actions/user";
import Config from "../constants/Config";
import HeroProfilePage from "../components/organisms/HeroProfilePage";
import LoginProfileBody from "../components/organisms/LoginProfileBody";
import RegisterProfileBody from "../components/organisms/RegisterProfileBody";
import NavTabs from "../components/molecules/NavTabs";
// import Loader from "../components/atoms/Loader";

const LoginRegister = (): React.Node => {
    const location = useLocation();

    const tabs = [
        {
            to: Config.routes.login,
            title: "Login",
        },
        {
            to: Config.routes.register,
            title: "Sign up",
        },
    ];

    return (
        <React.Fragment>
            <HeroProfilePage heading="Login or Sign up" />

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-md-offset-2 col-md-8">
                        <NavTabs tabs={tabs} />
                    </div>
                </div>
            </div>

            <Switch location={location}>
                <Route
                    path={Config.routes.login}
                    component={LoginProfileBody}
                />
                <Route
                    path={Config.routes.register}
                    component={RegisterProfileBody}
                />
                <Redirect to={Config.routes.login} />
            </Switch>
        </React.Fragment>
    );
};

export default LoginRegister;
